module.exports = __webpack_public_path__ + "images/something-better-bg.jpg";